import React, {useEffect} from 'react'
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";


// components
import NewItem from "../../../components/buttons/newItem";
import TypeRestrictionForm from "./_form";
import TypeRestrictionList from "./_list";


//actions
import { clearState as clearMainState, setApp } from "../../../redux/actions/generalActions/mainActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { showLoader } from "../../../components/loader/loader";

const TypeRestriction = props => {
    const { loading, viewMode } = props?.mainState

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearMainState()
            props.clearListState()
        }
    },[])

    return <>
        { loading && showLoader() }

        <NewItem />

        <Row>
            <Col>
                {(
                    function (){
                        switch (viewMode){
                            case 'FORM':
                                return <TypeRestrictionForm />
                            default:
                                return <TypeRestrictionList />
                        }
                    }
                )()}
            </Col>
        </Row>
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
})

const mapActionsToProps = ({
    setApp,
    clearMainState,
    clearListState,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeRestriction)